import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaParallax from './VaParallax.vue'

export default withConfigTransport(VaParallax)
